import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
  successBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 40,
    backgroundColor: "#F2F2F2",
    bordeRadius: 8,
  },
  buttonBox: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 20,
  },
}));
